import { PapiDeviation } from '@wix/da-papi-types';

export function deviationHasFileSizeMetadata(deviation: PapiDeviation) {
  const file = deviation.extended?.originalFile;
  return !!(file && file.filesize && file.width && file.height);
}
